












import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class UDynamicLink extends Vue {
  // Props
  @Prop({ required: true })
  public link!: {
    type: string;
    props: object;
    event: object;
  };
  @Prop({ default: false })
  public disabled!: boolean;
}
